import React, { Component } from "react";
import styled from "styled-components";

const Li = styled.li`



  display: flex;
  text-decoration: none;
  padding: 10px 15px;
  div{display:flex;
  width:100%;
  flex-direction:column;
  justify-content:center;
  align-items:flex-start;
  padding-left:10px;
  z-index:100;
  cursor: pointer;
  :hover{
      background-color:#09886ce6;
      border-radius:20px;

  }
  }
`;

const Ul = styled.ul`
background:#18a586;
border-radius:20px;
width:100%;
position:absolute;
`


export class SearchList extends Component {
    changeCover=(key)=>{
        this.props.setSearch(key)
  }
  render() {
    return (
      <Ul>
        {this.props.item.length > 0 &&
          this.props.item[0].map((item, key) => (
              key<5&&
            (<Li key={key}  onClick={()=>this.changeCover(key)}>
              <img src={item.album.images[2].url} alt="cover" />
              <div>
              <p> {item.name}</p>
              <p>{item.artists[0].name}</p>
              </div>
            </Li>)
          ))}
      </Ul>
    );
  }
}

export default SearchList;
